<nb-card >
  <nb-card-header>
    <div class="row">
      <div class="col-lg-12 col-12">
        <h4>Room Details</h4>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-lg-6 col-12">
        <h5>Room: <b>{{this.room.name}}</b></h5>
        <h5>Capacity: <b>{{this.room.roomCapacity}}</b></h5>
      </div>
      <div class="col-lg-6 col-12">
        <h5 class="margin">Description: <b>{{this.room.description}}</b></h5>
      </div>
    </div>

    <div class="row" style="margin-top: 5px;">
      <div class="col-lg-6 col-4">
        <table class="table" style="border: 0px;" [nbSpinner]="this.roomLoading">
          <thead>
            <tr>
              <th>
                <h6>{{"Farm" | tenantWords}}</h6>
              </th>
              <th>
                <h6>{{"Block" | tenantWords}}</h6>
              </th>
              <th>
                <h6>{{"Storage Type" | tenantWords}}</h6>
              </th>
              <th>
                <h6>Received Qty</h6>
              </th>
            </tr>
          </thead>
          <tbody >
            <tr *ngFor="let l of roomData?.growers">
              <td>
                <h6>{{l.farmName}}</h6>
              </td>
              <td>
                <h6>{{l.blockName}}</h6>
              </td>
              <td>
                <h6>{{l.storageTypeName}}</h6>
              </td>
              <td>
                <h6>{{l.receivedQty | number}}</h6>
              </td>
            </tr>
          </tbody>
        </table>-
      </div>


      <div class="col-lg-4 col-3" style="text-align: center;">
        <header><h6>Received Vs. Planned</h6></header>
        @if(roomData?.data?.length > 0){
          <canvas style="overflow: visible;" id="barChart" baseChart
          [data]="roomData.graphData"  [legend]="false"
            [options]="barChartOptions" [legend]="barChartLegend"
            [type]="barChartType" >
          </canvas>
        }
      </div>
      <div class="col-lg-2 col-3" style="text-align: center;">
          <header><h6>Actions</h6></header>
          <button mat-icon-button (click)="openDialog(roomData);">
            <fa-icon [icon]="faBars" size="lg"></fa-icon>
          </button>
      </div>
    </div>

  </nb-card-body>
  <nb-card-footer style="margin-top: 10px; border: none;">
    <div class="row">
      <div class="col-lg-12 col-12">
        <button mat-button type="button" style="padding: 5px;" (click)="close()">
          <fa-icon [icon]="faArrowAltCircleLeft" size="lg"></fa-icon>
          Cancel
        </button>
      </div>
    </div>
  </nb-card-footer>
</nb-card>